import React from 'react';
import Badge from 'housecall-ui/dist/DesignSystem/DataDisplay/Badges/Badge';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Drawer from 'housecall-ui/dist/DesignSystem/Navigation/Drawers/Drawer';
import DrawerHeader from 'housecall-ui/dist/DesignSystem/Navigation/Drawers/DrawerHeader';
import Tab from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tab';
import Tabs from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tabs';
import useTheme from 'housecall-ui/dist/DesignSystem/Styles/useTheme';
import AppStore from 'housecall-ui/dist/HousecallComponents/Apps/DownloadApps/AppStore';
import PlayStore from 'housecall-ui/dist/HousecallComponents/Apps/DownloadApps/PlayStore';
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close';
import PropTypes from 'prop-types';

import { DrawerFooter } from './DrawerFooter';

function HamburgerDrawer({ activeTab, open, onCloseClick = () => {}, toolbarTabs, packageLogo }) {
  const theme = useTheme();

  return (
    <Drawer open={open} version="v2" anchor="left" onClose={onCloseClick}>
      <DrawerHeader>
        <Grid container justify="flex-end">
          <IconButton onClick={onCloseClick}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DrawerHeader>
      {packageLogo}
      <Tabs orientation="vertical" tabSize="med" value={activeTab || false} version="v2">
        {toolbarTabs.map((item, index) => (
          <Tab
            key={index}
            version="v2"
            label={<Typography variant="h3">{item.label}</Typography>}
            secondary={<Badge color="info" badgeContent={item.badgeCount} version="v2" />}
            value={item.value}
            href={item.href}
            onClick={item.onClick}
          />
        ))}
      </Tabs>
      <DrawerFooter>
        <Grid container spacing={2}>
          <Grid item>
            <AppStore fill={theme.palette.secondary.main} />
          </Grid>
          <Grid item>
            <PlayStore fill={theme.palette.secondary.main} />
          </Grid>
        </Grid>
      </DrawerFooter>
    </Drawer>
  );
}

HamburgerDrawer.propTypes = {
  activeTab: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  toolbarTabs: PropTypes.arrayOf(PropTypes.object),
  packageLogo: PropTypes.element,
};

export default HamburgerDrawer;
